import React, { useCallback } from "react";
import List from "@commonComponents/List";
import CustomOfficeForm from "./customOfficeForm";
import { useSelector } from "react-redux";
import { selectCustomOfficeTypeList,selectCustomOfficeList } from "@EUForms/selectors";

const CustomOfficeDetail = ({dataSource,...rest}) => {
 
  const isOfficeTypeAleadyExist=useCallback((selectedOffice)=>dataSource.some(c=>c.type==selectedOffice),[dataSource])
  const customOfficeTypeList=useSelector(selectCustomOfficeTypeList)
  const officeNameList=useSelector(selectCustomOfficeList) 

  const renderItem=useCallback((item)=> <CustomOfficeForm 
  dataSource={item} 
  key={item.id} 
  isOfficeTypeAleadyExist={isOfficeTypeAleadyExist}
  customOfficeTypeList={customOfficeTypeList}
  officeNameList={officeNameList}
  {...rest} />,[isOfficeTypeAleadyExist,customOfficeTypeList,officeNameList,rest]
)

  return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem}/>
  
}

export default React.memo(CustomOfficeDetail)
